function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { CloseOutlined } from "@ant-design/icons";
import { NodesUtil } from "../NodesUtil";
import { Button } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useSignal } from "@preact/signals-react";
import style from "./Stock.module.css";
import { get } from "lodash";
import classNames from "classnames";
export function Stock(props) {
  var _ref, _props$userRelatedDat, _props$userRelatedDat2, _props$node, _props$featureTags, _props$featureTags2, _props$featureTags3, _props$featureTags4;
  var showErrorImg = useSignal(true);

  // 方便断点
  var value = get(props, "content") || get(props, "textAreaValue.0.results.0.content");
  var disableAddPreview = props.disableAddPreview;
  var isShare = props.isShare;
  var userInputPrice = (_ref = (_props$userRelatedDat = props === null || props === void 0 || (_props$userRelatedDat2 = props.userRelatedData) === null || _props$userRelatedDat2 === void 0 ? void 0 : _props$userRelatedDat2.userInputPrice) !== null && _props$userRelatedDat !== void 0 ? _props$userRelatedDat : props === null || props === void 0 || (_props$node = props.node) === null || _props$node === void 0 || (_props$node = _props$node.data) === null || _props$node === void 0 || (_props$node = _props$node.userRelatedData) === null || _props$node === void 0 ? void 0 : _props$node.userInputPrice) !== null && _ref !== void 0 ? _ref : 0;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showTradeBtns = _useState2[0],
    setShowTradeBtns = _useState2[1];
  var shareClass = isShare ? style["share"] : props.locus === "saas" ? style["preview"] : "";
  var container = {
    show: {
      transition: {
        staggerDirection: -1,
        staggerChildren: 0.01
      }
    },
    hide: {
      transition: {
        staggerChildren: 0.01
      }
    }
  };
  var tradeOptionsItem = {
    init: {
      opacity: 0,
      y: "120px"
    },
    show: {
      opacity: 1,
      y: "0"
    },
    hide: {
      opacity: 0,
      y: "120px",
      transition: {
        duration: 0.25,
        type: "spring",
        ease: "easeOut"
      }
    }
  };
  var sellItem = tradeOptionsItem;
  var buyItem = tradeOptionsItem;
  sellItem.init.y = "80px";
  sellItem.hide.y = "80px";
  buyItem.init.y = "40px";
  buyItem.hide.y = "40px";
  var opacityItem = {
    init: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        type: "spring",
        ease: "easeInOut"
      }
    },
    hide: {
      opacity: 0,
      transition: {
        duration: 0.5,
        type: "spring",
        ease: "easeOut"
      }
    }
  };
  var clickTrade = function clickTrade() {
    setShowTradeBtns(true);
  };
  var clickBuyBtn = function clickBuyBtn() {
    var _props$handleBuyStock;
    props === null || props === void 0 || (_props$handleBuyStock = props.handleBuyStock) === null || _props$handleBuyStock === void 0 || _props$handleBuyStock.call(props, value, userInputPrice);
    setShowTradeBtns(false);
  };
  var handleImageLoadError = function handleImageLoadError() {
    var _props$handleImageLoa;
    showErrorImg.value = true;
    (_props$handleImageLoa = props.handleImageLoaded) === null || _props$handleImageLoa === void 0 || _props$handleImageLoa.call(props);
  };
  useEffect(function () {
    // url变化后需要重新加载
    showErrorImg.value = false;
  }, [value === null || value === void 0 ? void 0 : value.logo]);
  return /*#__PURE__*/React.createElement("section", {
    className: "CardHomeStock ".concat(style[props.className], " ").concat(props.fontSize, " ").concat(shareClass)
  }, /*#__PURE__*/React.createElement("div", {
    className: (_props$featureTags = props.featureTags) !== null && _props$featureTags !== void 0 && _props$featureTags.showBuyButton ? "CardHomeStockBox" : ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "CardHomeStockTop"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("CardHoeStockInfo", _defineProperty({}, style.hiddenContent, ((_props$featureTags2 = props.featureTags) === null || _props$featureTags2 === void 0 ? void 0 : _props$featureTags2.showBuyButton) && showTradeBtns))
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "CardHomeStockName"
  }, !NodesUtil.isEmpty(value === null || value === void 0 ? void 0 : value.name) ? value.name : "-"), /*#__PURE__*/React.createElement("p", {
    className: "CardHomeStockSymbol"
  }, !NodesUtil.isEmpty(value === null || value === void 0 ? void 0 : value.symbol) ? value.symbol : "-")), /*#__PURE__*/React.createElement("div", {
    className: "CardHomeStockLogo"
  }, !showErrorImg.value && (value === null || value === void 0 ? void 0 : value.logo) && /*#__PURE__*/React.createElement("img", {
    src: value === null || value === void 0 ? void 0 : value.logo,
    className: "CardHomeStockImg",
    onLoad: props.handleImageLoaded,
    onError: handleImageLoadError,
    alt: "logo"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames("CardHomeStockContent", _defineProperty({}, style.hiddenContent, ((_props$featureTags3 = props.featureTags) === null || _props$featureTags3 === void 0 ? void 0 : _props$featureTags3.showBuyButton) && showTradeBtns))
  }, /*#__PURE__*/React.createElement("p", {
    className: "CardHomeStockPrice"
  }, !NodesUtil.isEmpty(value === null || value === void 0 ? void 0 : value.price) ? value.price : "-"), /*#__PURE__*/React.createElement("p", {
    className: "CardHomeStockVolumeNum"
  }, value === null || value === void 0 ? void 0 : value.volume)), ((_props$featureTags4 = props.featureTags) === null || _props$featureTags4 === void 0 ? void 0 : _props$featureTags4.showBuyButton) && /*#__PURE__*/React.createElement("div", {
    className: "CardHomeStockBottomFixed ".concat(disableAddPreview || props.locus === "saas" ? "" : "showPreviewBtn")
  }, /*#__PURE__*/React.createElement(AnimatePresence, null, !showTradeBtns ? /*#__PURE__*/React.createElement(motion.div, {
    key: "cardHomeStockCancelBtn",
    variants: opacityItem,
    initial: "init",
    animate: "show",
    exit: "hide",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !props.buyStockPermission || !disableAddPreview && props.locus !== "saas",
    className: "CardHomeStockTradeBtn",
    onClick: clickTrade,
    shape: "round",
    size: "large"
  }, "Trade")) : /*#__PURE__*/React.createElement("div", {
    className: "CardHomeStockTradeBtnGroup"
  }, /*#__PURE__*/React.createElement(motion.div, {
    key: "cardHomeStockTradeContainer",
    variants: container,
    initial: "init",
    animate: "show",
    exit: "hide",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(motion.div, {
    key: "cardHomeStockTradeOptionsBtn",
    variants: tradeOptionsItem
  }, /*#__PURE__*/React.createElement(Button, {
    className: "CardHomeStockTradeBtn CardHomeStockTradeOptionsBtn",
    shape: "round",
    size: "large"
  }, "Trade Options")), /*#__PURE__*/React.createElement(motion.div, {
    key: "cardHomeStockSellBtn",
    variants: sellItem
  }, /*#__PURE__*/React.createElement(Button, {
    className: "CardHomeStockTradeBtn CardHomeStockSellBtn",
    shape: "round",
    size: "large"
  }, "Sell")), /*#__PURE__*/React.createElement(motion.div, {
    key: "cardHomeStockBuyBtn",
    variants: buyItem
  }, /*#__PURE__*/React.createElement(Button, {
    className: "CardHomeStockTradeBtn CardHomeStockBuyBtn",
    shape: "round",
    size: "large",
    onClick: clickBuyBtn
  }, "Buy"))), /*#__PURE__*/React.createElement(motion.div, {
    key: "cardHomeStockCancelBtn",
    variants: opacityItem,
    initial: "init",
    animate: "show",
    exit: "hide",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "CardHomeStockCancelBtn",
    onClick: function onClick() {
      return setShowTradeBtns(false);
    },
    icon: /*#__PURE__*/React.createElement(CloseOutlined, null),
    type: "ghost",
    shape: "round",
    size: "large"
  }))))))));
}